<span class="badge" [class]="type">
  <i *ngIf="icon" [class]="icon"> </i>
  {{ text }}
</span>
